import { User } from "@/types/auth";

const LEGACY_STORAGE_KEY = "activeOrganizationId";

function storageKey(userId: number): string {
  return `${LEGACY_STORAGE_KEY}:${userId}`;
}

export function getStoredActiveOrganizationId(userId: number): number | null {
  const raw = localStorage.getItem(storageKey(userId));
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function setStoredActiveOrganizationId(userId: number, id: number): void {
  localStorage.setItem(storageKey(userId), String(id));
  // Drop legacy unscoped key so it cannot pollute other accounts.
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

export function clearStoredActiveOrganizationId(userId?: number | null): void {
  if (userId != null) {
    localStorage.removeItem(storageKey(userId));
  }
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

/**
 * Resolve the active org for list filtering.
 * Returns a stored preference only when it is still a valid membership;
 * otherwise null ("All organizations") — never auto-selects the first org.
 */
export function resolveActiveOrganizationId(user: User | null): number | null {
  if (!user?.organizations?.length) {
    return null;
  }
  const stored = getStoredActiveOrganizationId(user.id);
  if (stored != null && user.organizations.some((org) => org.id === stored)) {
    return stored;
  }
  return null;
}

export function userHasMultipleOrganizations(user: User | null): boolean {
  return (user?.organizations?.length ?? 0) > 1;
}

export function shouldShowOrganizationColumn(user: User | null): boolean {
  if (!user) return false;
  if (user.role === "admin") return false;
  return userHasMultipleOrganizations(user);
}
